"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemStatus = exports.NominationStatus = exports.IssueStatus = void 0;
var IssueStatus;
(function (IssueStatus) {
    IssueStatus[IssueStatus["Completed"] = 0] = "Completed";
    IssueStatus[IssueStatus["Cancelled"] = 1] = "Cancelled";
    IssueStatus[IssueStatus["RequestedRefund"] = 2] = "RequestedRefund";
    IssueStatus[IssueStatus["Expired"] = 3] = "Expired";
    IssueStatus[IssueStatus["PendingWithBtcTxNotFound"] = 4] = "PendingWithBtcTxNotFound";
    IssueStatus[IssueStatus["PendingWithBtcTxNotIncluded"] = 5] = "PendingWithBtcTxNotIncluded";
    IssueStatus[IssueStatus["PendingWithTooFewConfirmations"] = 6] = "PendingWithTooFewConfirmations";
    IssueStatus[IssueStatus["PendingWithEnoughConfirmations"] = 7] = "PendingWithEnoughConfirmations";
})(IssueStatus = exports.IssueStatus || (exports.IssueStatus = {}));
var NominationStatus;
(function (NominationStatus) {
    NominationStatus[NominationStatus["Staked"] = 0] = "Staked";
    NominationStatus[NominationStatus["Unstaked"] = 1] = "Unstaked";
    NominationStatus[NominationStatus["Refunded"] = 2] = "Refunded";
})(NominationStatus = exports.NominationStatus || (exports.NominationStatus = {}));
var RedeemStatus;
(function (RedeemStatus) {
    RedeemStatus[RedeemStatus["Completed"] = 0] = "Completed";
    RedeemStatus[RedeemStatus["Expired"] = 1] = "Expired";
    RedeemStatus[RedeemStatus["Reimbursed"] = 2] = "Reimbursed";
    RedeemStatus[RedeemStatus["Retried"] = 3] = "Retried";
    RedeemStatus[RedeemStatus["PendingWithBtcTxNotFound"] = 4] = "PendingWithBtcTxNotFound";
    RedeemStatus[RedeemStatus["PendingWithBtcTxNotIncluded"] = 5] = "PendingWithBtcTxNotIncluded";
    RedeemStatus[RedeemStatus["PendingWithTooFewConfirmations"] = 6] = "PendingWithTooFewConfirmations";
    RedeemStatus[RedeemStatus["PendingWithEnoughConfirmations"] = 7] = "PendingWithEnoughConfirmations";
})(RedeemStatus = exports.RedeemStatus || (exports.RedeemStatus = {}));
//# sourceMappingURL=requestTypes.js.map